<template>
    <div>
        <b-button 
            v-b-toggle="target" 
            :class="'btn btn-light ' + classes"
            :id="id"
            @click="executarAcao"
        >
            {{ texto }}
            <span class="ml-1 float-right">
                <i :class="'fa ' + icone + ' fa-xs'"></i>
            </span>
        </b-button>
    </div>
</template>

<script>

const icones = {
    verMais: "fa-chevron-down",
    verMenos: "fa-chevron-up",
}

const textos = {
    verMais: 'Ver mais',
    verMenos: "Ver menos",
}

export default {
    data() {
        return {
            icone: '',
            texto: '',
        };
    },
    props: {
        classes: {
            type: String,
            default: "",
        },
        target: String,
        textoAbrir: {
            type: String,
            default: textos.verMais
        },
        textoFechar: {
            type: String,
            default: textos.verMenos
        },
        id: String,
    },
    methods: {
        executarAcao() {
            setTimeout(() => {
                if (!document.getElementById(this.target).classList.contains("show")) {
                    this.icone = icones.verMais
                    this.texto = this.textoAbrir
                } else {
                    this.icone = icones.verMenos
                    this.texto = this.textoFechar
                    document.getElementById(this.target).scrollIntoView({block: "end", behavior: "smooth"});  
                }
            }, 300);

            this.$emit('acaoVerMais');

        }
    },
    created() {
        this.icone = icones.verMais;
        this.texto = this.textoAbrir;
    }
};
</script>
